import React, { useState, useContext, useEffect } from 'react';
import _ from 'lodash';
import moment from 'moment';
import Select from 'react-select';
import { toast } from 'react-toastify';
import Datepicker from '../../../Common/form/datepicker';
import { ReportContext } from '../Report';
import { generateReport } from '../../../../services/reportsServices';
import { getCurrentUser } from '../../../../services/authService';
import RedirectToLogin from '../../../../utils/RedirectToLogin';
import { ReportsContext } from '../../Reports';
import Loading from '../../../Common/loading/loading';
import ReportPayroll from '../ReportPayroll/ReportPayroll';

function ReportToolFilters() {
  const reportsContext = useContext(ReportsContext);
  const reportContext = useContext(ReportContext);
  const reportData = reportContext.reportData;
  const [reportFilters, setReportFilters] = useState([]);
  const [reportFiltersRequired, setReportFiltersRequired] = useState(null);
  const [filterBy, setFilterBy] = useState(null);
  const [datePickerNameSelected, setDatePickerNameSelected] = useState(null);
  const [generateReportConfirmation, setGenerateReportConfirmation] = useState();
  const [loading, setLoading] = useState(false);
  const [departmentSelected, setDepartmentSelected] = useState();

  const reportFiltersBuilder = (selectedField) => {
    const withDependent = (selectedField) ? !!selectedField.id : false;
    const allFilters = reportData.filters;
    const filtersBuilder = [];

    for (let i = 0; i < allFilters.length; i++) {
      const filter = allFilters[i];

      if (withDependent && filter.dependent_value === selectedField.id ) {
        filtersBuilder.push( filter );
      }
      if (!filter.dependent_id) {
        filtersBuilder.push( filter );
      }
    }

    const requiredFiltersBuilder = [];
    for (let i = 0; i < filtersBuilder.length; i++) {
      const filterRequired = filtersBuilder[i];
      if (filterRequired.required) {
        requiredFiltersBuilder.push(filterRequired.field_name);
      }
    }

    const reportFilters =  _.orderBy(filtersBuilder, ['sort'], ['asc']);

    setReportFilters(reportFilters);
    setReportFiltersRequired(requiredFiltersBuilder);
  };

  useEffect(() => {
    reportData && reportData.filters && setReportFilters(reportData.filters);
    reportData && reportData.filters && reportFiltersBuilder();
  }, [reportData]);

  useEffect(() => {
    reportFilters.length !== 0 && reportFilters.map( (item) => {
      if (item.type === 'default') {
        setFilterBy({...filterBy, [item.field_name]: item.data[0].value });
      }
      return true
    });
  },[reportFilters]);
  
  // ** ACTIONS HANDLE
  // *********************************************************

  const validate = () => {
    let isValid = true;

    for (let idx = 0; idx < reportFiltersRequired.length; idx++) {
      const element = reportFiltersRequired[idx];
      if ( filterBy && filterBy[element] ) {
        isValid = false
      } 
      else {
        return true
      }
    }

    return isValid;
  };

  const handleOnChangeSelectFilter = selectedFilter => {
    // CUSTOM TIME RANGE FILTERS
    if (selectedFilter.field_name === 'department_id') {
      setDepartmentSelected(selectedFilter);
    }
    if (selectedFilter.field_name === 'time_range_id' && selectedFilter.id === 5) {
      reportFiltersBuilder(selectedFilter);
    } else if (selectedFilter.field_name === 'time_range_id') {
      reportFiltersBuilder();
    }

    const buildFilterBy = {
      ...filterBy,
      [selectedFilter.field_name]: selectedFilter.id.toString()
    }
    setFilterBy(buildFilterBy);
  };

  const handleChangeDatepicker = date => {
    const input = {
      name: datePickerNameSelected,
      value: moment(date).format('YYYY-MM-DD')
    }
    const buildFilterBy = { ...filterBy, [input.name]: input.value};

    setFilterBy(buildFilterBy);
  };

  const handleGenerateReport = async (exportReport) => {
    reportContext.setReportResults(null);
    let requestProperties = filterBy;

    if (exportReport) {
      requestProperties = {...filterBy, export_report: true}
    }

    setLoading(true);
    const { data } = await generateReport(reportData.endpoint, requestProperties);
    const success = data.success;
    if (!success) {
      const errorMessage ='Error generating the report';
      toast.error(errorMessage);
      return
    }

    setGenerateReportConfirmation({
      status: data.status,
      summary: data.summary,
      filters: data.filters
    });

    reportContext.setReportResults({
      filters: data.filters,
      rows: data.rows,
      files: data.files,
      totalized: data.totalized
    });

    setLoading(false);
  };

  const clearReportData = () => {
    setGenerateReportConfirmation() ;
    setFilterBy({
      department_id: null,
      customer_id: null,
      venue_id: null,
      time_range_id: null,
      start_date: null,
      end_date: null
    });
    setReportFiltersRequired(null);
    reportFiltersBuilder(null);
  }

  const handleResetReport = () => {
    reportContext.setReportResults(null);
    clearReportData();
  }

  // ** RENDERS
  // *********************************************************

  const renderSelect = item => {
    const filterIdx = filterBy && item.data.map(e => e.id).indexOf(Number(filterBy[item.field_name]));
    let data = item.data;
    if (item.field_name === 'customer_id' || item.field_name === 'venue_id') {
      if (departmentSelected) {
        data = item.data.filter(d => d.department_id === departmentSelected.id || d.department_id === 0);
      } else {
        data = item.data.filter(d => d.department_id === 0);
      }
    }
    return (
      <div className="filter-item">
        <label className={(item.required) ? 'required' : ''}>{item.label}</label>
        <Select
          className="select-style-default underline"
          isSearchable={true}
          value={item.data[filterIdx] || ''}
          options={data}
          getOptionLabel ={(option)=>option.name}
          getOptionValue ={(option)=>option.id}
          onChange={handleOnChangeSelectFilter}
        />
      </div>
    );
  };

  const renderDatepicker = (item) => {
    const date = filterBy ? moment(filterBy[item.field_name]).format() : null ;
    const dateSelected = (filterBy && filterBy[item.field_name]) ? new Date(date) : null;
    
    return (
      <div className="filter-item">
        <Datepicker
          selected={dateSelected}
          name={item.field_name}
          label={item.label}
          className="datepicker form-control form-control-sm"
          onChange={handleChangeDatepicker}
          onFocus={ ({ currentTarget: input }) => setDatePickerNameSelected(input.name)}
        />
      </div>
    )
  };

  return (
    !getCurrentUser()
      ? <RedirectToLogin location={reportsContext.props.location} />
      : <>
        { reportFilters.length !== 0 &&
          <>
            <section className="ReportToolFilters">
              <div className="row justify-content-between align-items-center">
                <div className="filters col-auto d-flex">
                  { reportFilters.map( (item, idx) => {
                      return (
                        <React.Fragment key={idx}>
                          { item.type === 'select' && renderSelect(item) }
                          { item.type === 'date' && renderDatepicker(item) }
                        </React.Fragment>
                      )
                    })
                  }
                  <span className="d-flex align-items-end justify-content-center">
                    <button type="button" className="btn btn-primary btn-generate-report"
                            disabled={loading || (reportFiltersRequired && validate())}
                      onClick={ () => handleGenerateReport() }
                    >
                      Generate
                    </button>
                    &nbsp;
                    <button type="button" className="btn btn-secondary"
                      onClick={ () => handleResetReport() }
                    >
                      Reset
                    </button>
                  </span>
                </div>
              </div>
            </section>

            {loading ?
              <div className="loader-container">
                <Loading active={loading} />
              </div> : null}
          </>
        }

        {/*PAYROLL REPORT*/}
        { generateReportConfirmation && generateReportConfirmation.summary &&
          <ReportPayroll
            generateReportConfirmation={generateReportConfirmation}
            reportContext={reportContext}
            reportsContext={reportsContext}
            handleGenerateReport={handleGenerateReport}
          />
        }
      </>
  )
}

export default ReportToolFilters
